/* eslint-disable no-case-declarations */
import _ from 'lodash';
import moment from 'moment-timezone';

import {
  LinkType,
  OncehubBookingStatuses,
  SCHEDULED_CALLS_BANNER_MESSAGES,
  VisitType,
} from './constants';

export const getScheduleVisitQueryParams = (patient, phone, linkType) => {
  if (_.isEmpty(patient)) {
    return '';
  }

  switch (linkType) {
    case LinkType.Oncehub:
      const name = `${patient.firstName || ''} ${patient.lastName || ''}`;
      const mobile = phone ? phone.phoneNumber?.substring(2) : '';
      const email = patient.email || '';
      const company = patient.id || '';

      return `?name=${name}&mobile=${mobile}&email=${email}&company=${company}`;
    case LinkType.Jotform:
      return `?mrn=${patient.id}`;
    default:
      return '';
  }
};

export const getVisitTypeLabel = (type) =>
  Object.values(VisitType).find((vt) => vt.value === type)?.label || 'Unknown';

export const checkMultipleScheduledCalls = (scheduledCalls = [], timeZone) => {
  const now = moment().tz(timeZone);

  const upcomingCalls = scheduledCalls.filter(
    (call) =>
      !now.isAfter(moment(call.scheduledAt).tz(timeZone)) &&
      call.status !== OncehubBookingStatuses.canceled.value,
  );

  const dateCounts = {};
  const dateTimeCounts = {};

  upcomingCalls.forEach((call) => {
    const date = moment(call.scheduledAt).tz(timeZone);
    const dayKey = date.format('YYYY-MM-DD');
    const timeKey = date.format('YYYY-MM-DD HH:mm');

    dateCounts[dayKey] = (dateCounts[dayKey] || 0) + 1;
    dateTimeCounts[timeKey] = (dateTimeCounts[timeKey] || 0) + 1;
  });

  return {
    hasMultipleCallsOnSameDay: Object.values(dateCounts).some((count) => count > 1),
    hasMultipleCallsAtSameTime: Object.values(dateTimeCounts).some((count) => count > 1),
  };
};

export const getScheduledCallsBannerState = (
  hasMultipleCallsAtSameTime,
  hasMultipleCallsOnSameDay,
) => {
  if (hasMultipleCallsAtSameTime) {
    return {
      showBanner: true,
      warningMessage: SCHEDULED_CALLS_BANNER_MESSAGES.SAME_TIME,
    };
  }

  if (hasMultipleCallsOnSameDay) {
    return {
      showBanner: true,
      warningMessage: SCHEDULED_CALLS_BANNER_MESSAGES.SAME_DAY,
    };
  }

  return {
    showBanner: false,
    warningMessage: '',
  };
};
